/*
 * Copyright 2025 Intuition Robotics ltd
 */
import type {PatientGender} from "@app/ir-q-app-common/types/care-center/user";
import type {ApiWithQuery} from "@intuitionrobotics/thunderstorm/shared/types";

export enum ScreeningStatus {
    PROPOSED               = "PROPOSED",
    REJECTED               = "REJECTED",
    DONE_BEFORE            = "DONE_BEFORE",
    CALLING_PCP            = "CALLING_PCP",
    MADE_APPOINTMENT       = "MADE_APPOINTMENT",
    SCHEDULED_TRANSPORT    = "SCHEDULED_TRANSPORT",
    WAITING_FOR_APPOINTMENT = "WAITING_FOR_APPOINTMENT",
    WENT_TO_APPOINTMENT    = "WENT_TO_APPOINTMENT",
}

export type UserScreeningStatus = {
    id: number;
    status: ScreeningStatus;
    screening_id: number;
    agent_id: string;
    date_made_timestamp: number;
    step_retries: number;
    last_retry_timestamp: number | null;
    appointment_date_timestamp: number | null;
    screening_period_id: number | null;
};

export type MedicalScreening = {
    id: number;
    name: string;
    period_gap: number;
    gender: PatientGender;
    minimum_age: number;
    maximum_age: number;
    screeningStatuses: UserScreeningStatus[] | null;
    currentScreeningStatus: UserScreeningStatus | null;
    isEnabled: boolean | null;
};

export type MedicalScreeningPeriod = {
    id: number;
    agent_id: string;
    start_date: number;
    primary_screening_id: number;
    all_screening_ids: number[];
    screening_ordinal: number;
}

export type MedicalScreeningDataResponse = {
    periods: MedicalScreeningPeriod[];
    screenings: MedicalScreening[];
}

export type Server_Api_MedicalScreeningSetEnabled = ApiWithQuery<`/medical_screening/${string}/${string}/set-enabled?enabled=${string}`, void, {enabled: boolean}>
export type Server_Api_GetMedicalScreenings = ApiWithQuery<`/medical_screening/${string}`, MedicalScreening[]>
export type Server_Api_GetMedicalScreeningPeriods = ApiWithQuery<`/medical_screening/${string}/periods`, MedicalScreeningPeriod[]>
